module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm2.33ba33d07064fd4900b979c72284c831.png";